import { ReactNode } from 'react';
import { View } from 'react-native';
import { styles } from './styles';

type UnderstandingProps = {
  grid: ReactNode;
  videoPlayer: ReactNode;
};

export const Understanding = ({ grid, videoPlayer }: UnderstandingProps) => {
  return (
    <View style={styles.flex1Row}>
      <View style={styles.flex2}>{grid}</View>
      {videoPlayer ? <View style={styles.flex1}>{videoPlayer}</View> : null}
    </View>
  );
};
